import axios from "axios";
import firebase from "firebase/app";
import "firebase/firestore";
import moment from "moment";

import { BASE_URL, getSubscriptionsRaw, promisePool, withRetries } from "./recnetApi";
import { parseToSeconds } from "./suscripciones";
import { normalizarUsuario } from "./usuarios";

/**
 * Ex-suscriptores: quienes tuvieron Recnet Plus y cancelaron.
 *
 * El índice masivo (`/users/subscriptions`) sólo trae el estado actual, sin
 * fechas. La fecha de cancelación está en la consulta por cliente
 * (`/subscription/{id}`), dentro de `inactive_subscription`. Como los clientes
 * que ya no están activos son pocos, se consulta uno por uno, con concurrencia
 * limitada.
 */

/** Suscripción cancelada más reciente de un cliente, con su fecha. */
async function fechaDeCancelacion(customerId) {
  const { data } = await withRetries(() =>
    axios.get(`${BASE_URL}/subscription/${customerId}`)
  );

  const inactivas = Array.isArray(data && data.inactive_subscription)
    ? data.inactive_subscription
    : [];
  if (!inactivas.length) return null;

  let mejor = null;
  for (const s of inactivas) {
    const sec = parseToSeconds(s.canceled_at) || parseToSeconds(s.ended_at);
    if (sec && (!mejor || sec > mejor)) mejor = sec;
  }
  return mejor ? moment.unix(mejor) : null;
}

/** Datos de `app_usuarios` para un correo (teléfono, fecha de registro). */
async function perfilPorCorreo(email) {
  try {
    const snap = await firebase
      .firestore()
      .collection("app_usuarios")
      .where("email", "==", String(email).toLowerCase())
      .limit(1)
      .get();
    return snap.empty ? null : normalizarUsuario({ id: snap.docs[0].id, ...snap.docs[0].data() });
  } catch (err) {
    console.warn("[exSuscriptores] no se pudo leer el perfil de", email, err);
    return null;
  }
}

export async function cargarExSuscriptores() {
  const clientes = await getSubscriptionsRaw();
  // Todo cliente que ya no está activo es candidato a ex-suscriptor; se queda
  // en la lista sólo si de verdad tiene una suscripción cancelada con fecha.
  const candidatos = clientes.filter((c) => !c.active);

  const filas = await promisePool(
    candidatos,
    async (c) => {
      const canceladaEn = c.id ? await fechaDeCancelacion(c.id).catch(() => null) : null;
      if (!canceladaEn) return null;

      const perfil = await perfilPorCorreo(c.email);
      return {
        name: c.name || (perfil && perfil.name) || "Sin nombre",
        email: c.email || "—",
        phone: (perfil && perfil.phone) || "—",
        creadoEnFormatted: (perfil && perfil.creadoEnFormatted) || "—",
        canceladaEn,
        cancelacionTexto: canceladaEn.format("DD/MM/YYYY"),
      };
    },
    6
  );

  return filas
    .filter(Boolean)
    .sort((a, b) => b.canceladaEn.valueOf() - a.canceladaEn.valueOf());
}
